const colors = {
    white: 'white',
    background: '#F2F5FA',
    primary: '#866b4c',
    gray: '#B6BBBF',
    gray2: '#F0F1F6',
    green: '#20D30F',
    orange: '#F5A800',
    red: '#FF5656',
    dark: '#9B9E9F',
    mantineGray9: '#212529',
    customBg: '#ADA996',
    customBg2: '#F2F2F2',
    customBg3: '#DBDBDB',
    custom36p: '#866b4c',
    custom36s: '#5b4a35',
    customGray: '#f1f3f5'
}

export default colors